export default __webpack_public_path__ + "static/media/facebook_icon.a46e87ca.svg";